import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCNIP9Sc059C98KinD34iF_xpormhfoJ6g",
  authDomain: "rpe-system.firebaseapp.com",
  projectId: "rpe-system",
  storageBucket: "rpe-system.firebasestorage.app",
  messagingSenderId: "1027698938035",
  appId: "1:1027698938035:web:6371eeb78089c2da1fa0c6"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
